import React, { useState, useEffect } from 'react';

const LiveIndicator = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const base = Math.floor(Math.random() * 86) + 95;
    setCount(base);

    const interval = setInterval(() => {
      setCount(prev => {
        const change = Math.floor(Math.random() * 7) - 3;
        const next = prev + change;
        return Math.max(80, Math.min(200, next));
      });
    }, Math.floor(Math.random() * 7000) + 8000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed top-[64px] sm:top-[72px] right-3 sm:right-4 z-30 flex items-center gap-1.5 bg-gray-900/70 backdrop-blur-sm px-2.5 py-1 rounded-full border border-green-500/20" data-testid="live-indicator">
      <div className="relative">
        <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
        <div className="absolute inset-0 w-1.5 h-1.5 bg-green-500 rounded-full animate-ping opacity-75"></div>
      </div>
      <span className="text-[10px] sm:text-xs font-semibold text-green-500 gaming-title">{count} ONLINE</span>
    </div>
  );
};

export default LiveIndicator;
